//
import { objectToQueryString } from "../../../helpers/objectToQueryString";
import { API } from "../../api";
async function getProductsAttributes(query) {
    const url = process.env.LETS_TRADE_PRODUCT_URL ?? "";
    return await new API().apiGet({
        baseUrl: url,
        endpoint: `v2/product/attributes${objectToQueryString(query)}`,
    });
}
export { getProductsAttributes };
